module.exports = __webpack_public_path__ + "img/ptt-applications-white.f94dcda3.svg";